import React from 'react';
import { Box } from '@mui/material';
import TopUtilityBar from '@/components/sections/TopUtilityBar';
import HeaderNav from '@/components/sections/HeaderNav';
import ProjectsSection from '@/components/sections/ProjectsSection';
import FooterSection from '@/components/sections/FooterSection';

export const ProjectsPage: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#0b0f19' }}>
      <TopUtilityBar />
      <HeaderNav />
      <ProjectsSection />
      <FooterSection />
    </Box>
  );
};

export default ProjectsPage;
